function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M438.093,114.04L70.991,1.097c-7.484-2.313-15.634-0.921-21.943,3.734 c-6.309,4.663-10.022,12.038-10.022,19.877v216.633c0,21.689,14.14,40.841,34.865,47.23l144.277,44.423v19.819v29.702v43.857 l-17.331-9.203v-34.931c-48.295,1.306-82.552,18.144-82.552,44.272c0,34.017,58.012,70.79,129.571,82.138 c71.573,11.341,129.586-7.034,129.586-41.051c0-29.565-43.814-61.203-102.276-76.432v-40.681L440.995,401.5 c7.498,2.313,15.649,0.921,21.958-3.734c6.309-4.656,10.022-12.038,10.022-19.877V161.277 C472.974,139.58,458.833,120.422,438.093,114.04z M416.151,321.565c0,3.133-1.494,6.084-4.018,7.948 c-2.523,1.863-5.772,2.421-8.774,1.493L97.255,236.852c-6.221-1.914-10.471-7.657-10.471-14.17V76.84 c0-3.133,1.494-6.084,4.017-7.948c2.524-1.864,5.773-2.415,8.774-1.494l306.104,94.183c6.222,1.914,10.472,7.658,10.472,14.17 V321.565z"
}));

function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.6c92a407.svg";
export { ForwardRef as ReactComponent };